import { paths } from 'src/routes/paths';

import { PATH_AFTER_LOGIN } from 'src/config-global';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export const navConfig = [
  {
    title: 'Home',
    icon: <Iconify icon="solar:home-2-bold-duotone" />,
    path: '/',
  },
  { title: 'About Me', path: paths.about, icon: <Iconify icon="icon-park-solid:people" /> },
  { title: 'Blogs', path: paths.post.root, icon: <Iconify icon="ooui:articles-ltr" /> },
  {
    title: 'Contact',
    path: paths.contact,
    icon: <Iconify icon="lets-icons:message-fill" />,
  },

  {
    title: 'Pages',
    path: '/pages',
    icon: <Iconify icon="simple-icons:powerpages" />,
    children: [
      {
        subheader: 'MORE ABOUT ME',
        items: [
          {
            title: 'Technical Skills',
            path: paths.skills,
          },
          {
            title: 'Services',
            path: paths.service,
          },
          { title: 'FAQs', path: paths.faqs },
        ],
      },

      {
        subheader: 'BLOG / ARTICLES',
        items: [
          { title: 'Post', path: paths.post.root },
          { title: 'Learning Hub', path: paths.comingSoon },
        ],
      },
      {
        subheader: 'PROJECTS',
        items: [
          { title: 'CodeVerse Hub', path: paths.comingSoon },
          { title: 'Frontend Foundry', path: paths.comingSoon },
        ],
      },
      {
        subheader: 'Dashboard',
        items: [{ title: 'Dashboard', path: PATH_AFTER_LOGIN }],
      },
    ],
  },
];
